const KEY_PREFIX = 'welya.plan-modal-dismissed.';

function storageKey(workspaceId: number): string {
  return `${KEY_PREFIX}${workspaceId}`;
}

export function isPlanModalDismissed(workspaceId: number): boolean {
  try {
    return window.localStorage.getItem(storageKey(workspaceId)) !== null;
  } catch {
    // stockage indisponible (navigation privée, bloqueur) : la modale se rouvrira, sans casse
    return false;
  }
}

export function markPlanModalDismissed(workspaceId: number): void {
  try {
    window.localStorage.setItem(storageKey(workspaceId), '1');
  } catch {
    // idem : la fermeture reste effective pour la visite en cours
  }
}
